import { render, staticRenderFns } from "./residentialAgreement.vue?vue&type=template&id=44b020dd&scoped=true"
import script from "./residentialAgreement.vue?vue&type=script&lang=js"
export * from "./residentialAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b020dd",
  null
  
)

export default component.exports